export type Entitlement = string;

export const TVM_LIMITED: Entitlement = "tvm:limited";
export const TVM_FULL: Entitlement = "tvm:full";
export const TVD_FULL: Entitlement = "tvd:full";

export const KNOWN_ENTITLEMENTS: readonly Entitlement[] = [
  TVM_LIMITED,
  TVM_FULL,
  TVD_FULL,
] as const;
